const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjkiIGhlaWdodD0iOSIgcng9IjIiIC8+CjxyZWN0IHg9IjEzIiB5PSIyIiB3aWR0aD0iOSIgaGVpZ2h0PSI5IiByeD0iMiIgLz4KPHJlY3QgeD0iMiIgeT0iMTMiIHdpZHRoPSI5IiBoZWlnaHQ9IjkiIHJ4PSIyIiAvPgo8cmVjdCB4PSIxMyIgeT0iMTMiIHdpZHRoPSI5IiBoZWlnaHQ9IjkiIHJ4PSIyIiAvPgo8L3N2Zz4K";
export {
  I as default
};
//# sourceMappingURL=list_2-7890ac85.mjs.map
